import { isReactNative } from 'ui-builder';
import EventPreviewLayoutMobile from './EventPreviewLayout.mobile';
import EventPreviewLayoutWeb from './EventPreviewLayout.web';

const Layout = isReactNative() ? EventPreviewLayoutMobile : EventPreviewLayoutWeb;

export default Layout;
